/*
* @描述: 回款详情
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-14 15:37:29
*/
<template>
    <el-dialog :before-close="handleDialogClose"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogVisible"
               :modal-append-to-body="false"
               class="custom_form_dialog invoice_dialog"
               title="回款详情"
               width="620px">
        <el-form class="custom_detail_form"
                 label-position="top"
                 size="small">
            <el-row :gutter="24" style="flex-wrap: wrap" type="flex">
                <el-col :span="24">
                    <div class="page_little_title">
                        <span class="title">订单信息</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="关联订单" prop="order_num">
                        <span class="link-label" v-text="repaymentInfo.order_no"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="客户联系人" prop="contact_name">
                        <span v-if="repaymentInfo.customer_contact_info"
                              v-text="repaymentInfo.customer_contact_info.name"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="订单总金额" prop="order_amount">
                        <span v-text="repaymentInfo.order_amount"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="销售" prop="order_amount">
                        <div class="custom_contact_field_wrap">
                            <PersonnelCard v-if="repaymentInfo.salesperson_info"
                                           :userId="repaymentInfo.salesperson_info.id">
                                <template slot="container">
                                    <img :src="repaymentInfo.salesperson_info.avatar || defaultImg" alt=""
                                         class="avatar">
                                    <span class="name" v-text="repaymentInfo.salesperson_info.name"></span>
                                </template>
                            </PersonnelCard>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="page_little_title">
                        <span class="title">回款信息</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="回款公司" prop="order_amount">
                        <span v-text="repaymentInfo.payment_company_name"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="回款日期" prop="order_amount">
                        <span v-text="repaymentInfo.payment_date"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="回款方式" prop="order_amount">
                        <span v-text="repaymentInfo.payment_method_name"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="本次回款金额" prop="order_amount">
                        <span v-text="repaymentInfo.payment_amount"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="备注" prop="order_amount">
                        <span v-text="repaymentInfo.remark?repaymentInfo.remark:'--'"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="附件" prop="attachments">
                        <div v-if="repaymentInfo.attachments.length" class="file_upload_wrap">
                            <ul class="upload_file_list">
                                <li v-for="(file,file_idx) in repaymentInfo.attachments"
                                    class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <img alt="" class="file_img"
                                             src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                            <p class="file_size" v-text="file.file_size"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="下载"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                  @click="handleClickDownloadFile(file)">
                                                <i class="iconfont icon-daochu"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-else>--</div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-image ref="preview_img"
                  :preview-src-list="previewImgList"
                  :src="previewImgSrc"
                  style="display:none">
        </el-image>
    </el-dialog>
</template>
<script>
    import {ReceivableDetail} from "@/api";
    import {getOSSData} from "@/utils/uploadOss";
    import PersonnelCard from "@/components/pComponents/PersonnelCard";

    export default {
        name: "RepaymentDetail",
        data() {
            return {
                loading: false,
                repaymentInfo: {},
                previewImgList: [],
                previewImgSrc: '',
                defaultImg: require('@/assets/images/default.jpg'),
                repaymentDetailDialogVisible: false,
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false,
            },
            receivable_no: {
                type: String,
                default: '',
            },
        },
        components: {PersonnelCard},
        created() {
            this.getReceivableDetail()
        },
        mounted() {
        },
        methods: {
            // 详情
            getReceivableDetail() {
                this.loading = true;
                ReceivableDetail({receivable_no: this.receivable_no}).then((res) => {
                    if (res.code === 200) {
                        this.repaymentInfo = res.data.basic_info;
                    }
                    this.loading = false;
                });
            },

            handleDialogClose() {
                this.$emit('update:dialogVisible', false)
                this.$emit('update:receivable_no', '')
            },

            //附件预览事件
            handleClickPreview(file) {
                if (file.file_type.includes('image')) {
                    this.previewImgList = [file.file_path]
                    this.previewImgSrc = file.file_path
                    this.$refs.preview_img.showViewer = true
                } else {
                    if (file.file_type.includes('pdf')) {
                        window.open(file.file_path)
                    } else {
                        this.$message.error('当前文件格式不支持预览，请下载后查看')
                    }
                }
            },

            //附件下载
            handleClickDownloadFile(file) {
                getOSSData(file.file_path, file.file_name);
            },
        },
    }
</script>
<style lang="scss">
    .invoice_dialog .el-dialog__body {
        padding: 24px;
    }
</style>